<template>
  <div class="user-icon">
    <span class="user-icon__initials font-primary--bold">{{initials}}</span>
  </div>
</template>

<script>
  export default {
    name: 'user-icon',

    props: ['fullname'],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{
      initials:function(){
        if(this.fullname != null) {
          var names = this.fullname.split(' ');

          // Remove empty string positions from array
          names = names.filter((name) => name.length > 0);

          var firstLetters = '';

          // If name consists of a single word
          if(names.length == 1) {
            firstLetters = names[0].substring(0,2);
          }
          // If name consists of more than one word
          else {
            while(names.length > 0 && firstLetters.length <= 2)
            {
              firstLetters += names.shift()[0];
            }
          }

          return firstLetters;
        }

        return '--';
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .user-icon{
    position:relative;
    display: inline-block;
    border:0.2rem @brand--primary-color solid;
    height:4rem;
    width:4rem;
    border-radius: 50%;
    color:@brand--primary-color;
  }

  .user-icon__initials{
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0.1em;
  }
</style>



// WEBPACK FOOTER //
// UserIcon.vue?9e9ca8f4